<div class="px-10">
  <div class="flex mb-4 gap-8 justify-between">
    <div class="w-1/2">
      <h1 class="leading-9">Contact Us</h1>
      <mat-divider class="my-2"></mat-divider>
      <p class="font-medium text-lg">Whether you have questions about features, trials, pricing, need a demo, or anything else, our team is ready to answer your questions.</p>
    </div>
    <div class="w-1/2">
      <h2 class="text-3xl text-right">Help</h2>
      <mat-divider class="my-2"></mat-divider>
      <div class="flex justify-end gap-4">
        @if ((isAuthenticated$ | async) === false) {
          <div class="text-left">
            <h3>Sales</h3>
            <hr class="w-64 h-1 border-0 rounded hr-green mt-4 mb-4" />
            <a href="mailto:qbsupport@colbitech.com">qbsupport&#64;colbitech.com</a>
          </div>
        }
        <div class="text-right">
          <h3>Technical Support</h3>
          <hr class="w-64 h-1 border-0 rounded hr-green mt-4 mb-4" />
          <a href="mailto:qbsupport@colbitech.com">qbsupport&#64;colbitech.com</a>
        </div>
      </div>
    </div>
    <div class="flex-1"></div>
  </div>
  <mat-card>
    <mat-card-header class="mb-2">
      <mat-card-title>Points of Contact</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="flex gap-4 mb-4">
        <div class="w-2/3">
          <p>
            Have questions about your application status or bidding requirements? We've got you covered! Our active agencies are listed below - <img src="/assets/icons/LightBulbOn-Accepting.png" class="inline" width="18" height="auto" /> a green lightbulb signals they're open for business, while <img src="/assets/icons/LightBulbOff-notAccepting.png" class="inline" width="13" height="auto" />
            white indicates they aren't taking applications at this time. Check out their profiles and contact them directly - it's that easy!
          </p>
        </div>
        <div class="w-1/3">
          <mat-form-field class="w-full">
            <mat-label>Search Clients</mat-label>
            <input matInput name="search" [ngModel]="searchQuery" (ngModelChange)="searchAgencies($event)" aria-label="Search Agencies" />
            @if (searchQuery !== '') {
              <button matSuffix mat-icon-button aria-label="Clear" (click)="searchAgencies('')">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
      </div>
      <!--end of the search block-->
      <div id="agency-list" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
        @for (agency of agenciesList; track agency.name) {
          <div class="agency-container col-span-1 border-2 border-gray-400 border-solid shadow-lg p-3 w-full">
            <div class="flex flex-col justify-between h-full">
              <!--Logo and Agency Name-->
              <div class="flex justify-between">
                <div class="flex flex-col w-full">
                  <div class="pl-2">
                    <p class="text-md md:text-lg lg:text-xl">
                      {{ agency.name }}
                    </p>
                    @if ((isAuthenticated$ | async) && agency.contactInfo.address1) {
                      <div class="pt-2 pb-2 text-xs md:text-sm lg:text-md">
                        <ol>
                          <li>
                            {{ agency.contactInfo.address1 }}
                          </li>
                          <li>{{ agency.contactInfo.city }},{{ agency.contactInfo.state }} {{ agency.contactInfo.zipCode }}</li>
                          <li>
                            <a [href]="agency.webAddress"> <!--{{ agency.agencyUrlTitle }}--></a>
                          </li>
                          <!-- <li class="pt-2">
                            <a [href]="contact.agencyAppealsUrl">Appeals Link</a>
                          </li> -->
                        </ol>
                      </div>
                    }
                  </div>
                </div>
                @if (agency.logoFile) {
                  <div
                    class="background-image-container w-1/3"
                    [ngStyle]="{
                      'background-image': 'url(https://securebids-test.s3.us-west-1.amazonaws.com/public/' + agency.linkToken + '/logo/' + agency.logoFile + ')',
                      width: agency.logoWidth + 'px',
                      height: agency.logoHeight + 'px',
                    }"
                  ></div>
                }
              </div>
              <!--address + appeals link and contact agency disappears when a user is not logged in-->
              <!--bottom  of the card-->
              <div class="flex flex-col">
                <div class="flex flex-start gap-3 mb-3">
                  @if (agency.contactInfo.fullName) {
                    <mat-icon [matTooltip]="agency.contactInfo.fullName" class="cursor-pointer" (click)="copyToClipboard(agency.contactInfo.fullName)">person</mat-icon>
                  }
                  @if (agency.contactInfo.email) {
                    <mat-icon [matTooltip]="agency.contactInfo.email" class="cursor-pointer" (click)="copyToClipboard(agency.contactInfo.email)">email</mat-icon>
                  }
                  @if (agency.contactInfo.phone) {
                    <mat-icon [matTooltip]="agency.contactInfo.phone" class="cursor-pointer" (click)="copyToClipboard(agency.contactInfo.phone)">phone</mat-icon>
                  }
                  @if (agency.webAddress) {
                    <a class="cursor-pointer" href="{{ agency.webAddress }}" target="_blank" matTooltip="Visit Website">
                      <mat-icon>language</mat-icon>
                    </a>
                  }
                </div>
                <div class="flex justify-between">
                  <div class="flex flex-row gap-x-2">
                    <div class="w-15">
                      @if (agency.isAcceptingPrequal) {
                        <img src="/assets/icons/LightBulbOn-Accepting.png" />
                      } @else {
                        <img src="/assets/icons/LightBulbOff-notAccepting.png" />
                      }
                    </div>
                    <div>Prequalifications</div>
                  </div>
                  <div class="flex flex-row gap-x-2">
                    <div class="w-15">
                      @if (agency.isAcceptingCUPCCAA) {
                        <img src="/assets/icons/LightBulbOn-Accepting.png" />
                      } @else {
                        <img src="/assets/icons/LightBulbOff-notAccepting.png" />
                      }
                    </div>
                    <div>CUPCCAA</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
